// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for style selector panel */

.card-block{
	height: 250px;
  width: 250px;
	background-color: #fff;
	border: solid;
  border-color: #0dcaf0;
	background-position: center;
	background-size: cover;
	border-radius: 12px;
  overflow: hidden;
}

.selector-panel{
	overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Generator/StyleSelector.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;CACC,aAAa;EACZ,YAAY;CACb,sBAAsB;CACtB,aAAa;EACZ,qBAAqB;CACtB,2BAA2B;CAC3B,sBAAsB;CACtB,mBAAmB;EAClB,gBAAgB;AAClB;;AAEA;CACC,cAAc;AACf","sourcesContent":["/* Styling for style selector panel */\r\n\r\n.card-block{\r\n\theight: 250px;\r\n  width: 250px;\r\n\tbackground-color: #fff;\r\n\tborder: solid;\r\n  border-color: #0dcaf0;\r\n\tbackground-position: center;\r\n\tbackground-size: cover;\r\n\tborder-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selector-panel{\r\n\toverflow: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
